/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_334300da .ms-Suggestions-itemButton{padding:0;border:none}.callout_334300da .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_334300da";